import { graphql } from "@/lib/gql/__generated__";

export const SiteControllerSettingAirHostReservationSyncStart_SettingPage_Mutation = graphql(`
	mutation SiteControllerSettingAirHostReservationSyncStart_SettingPage(
		$input: SiteControllerSettingAirHostReservationSyncStartInput!
	) {
		siteControllerSettingAirHostReservationSyncStart(input: $input) {
			userErrors
			started
		}
	}
`);
